import { defineComponent as _defineComponent } from 'vue'
import { ref, defineAsyncComponent } from 'vue'
import type { Ref } from 'vue'
import { useSubmit } from './FormMixin'
import { useRoute } from 'vue-router'
import { passwordRecover } from '@/services/auth.service'
import useCaptcha from '@utils/useCaptcha'
import useGlobal from '@/composables/useGlobal'


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordReset',
  emits: ['changeForm'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const vueRecaptcha = defineAsyncComponent(() => import('vue3-recaptcha2'))

const {
  key,
  form,
  recaptcha,
  captchaToken,
  recaptchaVerified,
  verify,
  reset,
} = useCaptcha()

const emit = __emit

const { $t } = useGlobal()
const load = ref(false) 
const emailIsSended = ref(false)
const nonFieldErrors = ref("")
const email = ref("")

const toResetForm = () => {
  emit('changeForm', true)
}

const request = (sendData, control) => {
  if (captchaToken.value) {
    useSubmit(send({...sendData, recaptcha: captchaToken.value}, control), control)
  } else {
    verify()
  }
}

const send = async (sendData: any, control: any) => {
  try {
      load.value = true
      const { redirectLink } = (await passwordRecover.execute({}, {
        ...sendData,
      }))
      emailIsSended.value = true
      load.value = false
  } catch (e) {
    // reset()
    load.value = false
    return Promise.reject(e)
  }
}



const __returned__ = { vueRecaptcha, key, form, recaptcha, captchaToken, recaptchaVerified, verify, reset, emit, $t, load, emailIsSended, nonFieldErrors, email, toResetForm, request, send, ref, defineAsyncComponent, get useSubmit() { return useSubmit }, get useRoute() { return useRoute }, get passwordRecover() { return passwordRecover }, get useCaptcha() { return useCaptcha }, get useGlobal() { return useGlobal } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})